// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1CKax","label":"Completed_label__10k-L"};